import { createContext } from 'react';

const EchoContext = createContext(null);

export default EchoContext;
